export default {
      id: "cheese-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "img/icons.svg#cheese",
      toString: function () {
        return this.url;
      }
    }